import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Placeholder shown while a code-split page chunk is fetched.
 *
 * Deliberately the same spinner treatment `FeatureRoute` uses while flags settle, so the two waits
 * a user can hit on the way into a page look like one thing rather than two. It renders inside the
 * layout's main region, so the header and sidebar stay put and only the content area changes.
 */
const PageSkeleton: React.FC = () => (
  <Box
    role="status"
    aria-live="polite"
    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8, flexDirection: 'column', gap: 2 }}
  >
    <CircularProgress aria-label="Loading page" />
  </Box>
);

export default PageSkeleton;
